import React, { useState } from 'react';
import { Box, Text } from 'rebass/styled-components';
import { Message } from '@getro/rombo';

import SessionLayout from '../../components/layout/Session';
import { SignInForm } from '../../components/molecules/signInForm';
import { SocialOAuthButtons } from '../../components/molecules/socialOAuthButtons';
import { openChat } from '../../helpers/supportChat';
import pageHoc from '../../hocs/pageHoc';

const pageTitle = 'Login';

const Login = () => {
  const [oAuthError, setOAuthError] = useState(null);

  return (
    <SessionLayout title="Welcome back!" subtitle="Log in to your Getro account.">
      <SocialOAuthButtons
        mt="56px"
        onSuccess={() => {
          setOAuthError(null);
        }}
        onError={(e) => {
          setOAuthError(e);
        }}
      />
      {!!oAuthError && (
        <Message
          mt="8px"
          type="error"
          content={
            oAuthError.status === 401 ? (
              oAuthError.data?.error
            ) : (
              <Text>
                There was an unexpected error, please try again or{' '}
                <Text as="span" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openChat}>
                  contact us
                </Text>
                .
              </Text>
            )
          }
        />
      )}
      <Box mt="40px" pb="16px" sx={{ position: 'relative' }}>
        <Box width="160px" my="0" mx="auto" sx={{ borderTop: '1px solid', borderColor: 'border.subtle' }} />
        <Text
          px="24px"
          fontWeight="medium"
          fontSize="14px"
          color="text.subtle"
          width="fit-content"
          bg="neutral.0"
          sx={{ position: 'absolute', top: '-8px', left: '50%', transform: 'translateX(-50%)' }}
        >
          OR
        </Text>
      </Box>
      <SignInForm />
      <Box mt="56px" sx={{ textAlign: 'center' }}>
        <Text fontSize="14px" color="text.subtle">
          Getro is currently invite-only. If you don’t have a login, check in with your network admin.
        </Text>
      </Box>
    </SessionLayout>
  );
};

export default pageHoc({ title: pageTitle })(Login);
